import { useCallback } from 'react';
import * as track from 'lib/gaTracking/crossPageEvents';
import { contactUsModalProps } from '../ExpiredCardModal';
import useModal from 'hooks/useModal';

export const useExpiredCardModal = () => {
  const { showModal } = useModal();

  return useCallback(() => {
    track.expiredCreditCardModalOpened();
    showModal({
      ...contactUsModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.expiredCreditCardModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};
